import {
  type ItemRenderExtensionOptions,
  createItemRenderExtension,
  createItemRenderExtensions,
  useItemRenderExtensions,
} from './render-extension';

export type CodeBlockItem = {
  language: string;
  content: string;
};

export type CodeBlockExtensionOptions =
  ItemRenderExtensionOptions<CodeBlockItem> & {
    parseLegacyContent?: (content: string) => CodeBlockItem | null;
  };

export const CodeBlockExtensions =
  createItemRenderExtensions<CodeBlockExtensionOptions>({
    id: 'code-block',
  });

export const createCodeBlockExtension = (options: CodeBlockExtensionOptions) =>
  createItemRenderExtension<CodeBlockExtensionOptions>(options);

const NO_CODE_BLOCK_EXTENSIONS: CodeBlockExtensionOptions[] = [];

export const useCodeBlockExtensions = (): CodeBlockExtensionOptions[] => {
  const extensions =
    useItemRenderExtensions<CodeBlockExtensionOptions>(CodeBlockExtensions);
  return extensions.length > 0 ? extensions : NO_CODE_BLOCK_EXTENSIONS;
};
